/* Rug Branch — motion layer. Load after the page scripts.
   Emits `rb:ready` on document once any cover (loader / page transition) has lifted;
   app.js waits for it before revealing content. */
(function () {
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const LOGO = (window.RBUI && RBUI.src(RBUI.LOGO, 600)) || '';
  const ss = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* ignore */ } },
    del(k) { try { sessionStorage.removeItem(k); } catch (e) { /* ignore */ } },
  };
  const ready = () => { root.classList.remove('hold'); document.dispatchEvent(new Event('rb:ready')); };

  if (reduce) {
    root.classList.remove('preload', 'pt-in', 'hold'); ready();
    window.RBMotion = { fly: () => Promise.resolve() };
    return;
  }
  root.classList.add('m-on');
  if (fine) root.classList.add('fine');

  /* ---------- 1. The motion reel (homepage, first visit per session) ----------
     Ten seconds: loom strings, the Aegis rug weaving, a dive into the real Aegis room photograph, the room sketching
     itself from the photo's own edges, the sketch hung in a gallery of the store's rugs, kinetic type, then a pen that
     reveals the Rug Branch logo.
     Drawn live on a canvas (assets/rb-reel.js). Tap, Esc or "Skip intro" ends it; it lifts onto the page. */
  function loader() {
    const T = (window.RBCFG && window.RBCFG.t) || {};
    const el = document.createElement('div');
    el.className = 'loader loader-reel';
    el.innerHTML = `<canvas class="reel" aria-hidden="true"></canvas><button class="reel-skip" type="button">${T.skip_intro || 'Skip intro'}</button>`;
    document.body.appendChild(el);
    root.classList.remove('preload');
    ss.set('rb_loaded', '1');
    let done = false, reel = null;
    const onResize = () => reel && reel.size(innerWidth, innerHeight, Math.min(2, window.devicePixelRatio || 1));
    const onKey = (e) => { if (e.key === 'Escape') lift(); };
    const lift = () => {
      if (done) return; done = true;
      if (reel) reel.stop();
      window.removeEventListener('resize', onResize); document.removeEventListener('keydown', onKey);
      el.classList.add('lift');
      setTimeout(ready, 250);
      setTimeout(() => { el.remove(); root.classList.remove('reel-on'); }, 1100);
    };
    el.addEventListener('click', lift);
    document.addEventListener('keydown', onKey);
    const start = () => {
      if (done) return;
      if (!window.RBReel) { lift(); return; }
      const split = (v, d) => (v ? String(v).split('|') : d);
      // the reel is built on the Aegis rug: its room photograph and the store's own logo
      const big = Math.max(innerWidth, innerHeight) * Math.min(2, window.devicePixelRatio || 1) > 1400;
      const hero = document.querySelector('.hero-arch img');
      const photo = hero && /LE5102IV_6/.test(hero.currentSrc || hero.src) ? (hero.currentSrc || hero.src) : `https://cdn.shopify.com/s/files/1/0556/4324/2519/files/LE5102IV_6.jpg?v=1772438940&width=${big ? 2000 : 1200}`;
      const logo = window.RBUI && window.RBUI.LOGO ? window.RBUI.src(window.RBUI.LOGO, 1600) : '';
      const imgs = [...document.querySelectorAll('.wall[data-wall] img')].slice(0, 10).map((i) => {
        let s = i.currentSrc || i.getAttribute('src') || ''; if (s.startsWith('//')) s = 'https:' + s;
        return s ? s.replace(/([?&])width=\d+/, '$1width=540') : '';
      }).filter(Boolean);
      reel = window.RBReel.create(el.querySelector('canvas'), {
        photo: photo.startsWith('//') ? 'https:' + photo : photo, logo: logo && logo.startsWith('//') ? 'https:' + logo : logo, images: imgs,
        labels: { words: split(T.reel_words, undefined), scenes: split(T.reel_scenes, undefined), tag: T.reel_tag, note: T.loader_note, no: T.no },
      });
      onResize();
      window.addEventListener('resize', onResize);
      reel.play(lift);
    };
    // fonts first so the type sets correctly, but never wait more than 1.2s
    const f = document.fonts ? Promise.all([document.fonts.load('400 80px "Bodoni Moda"'), document.fonts.load('italic 400 80px "Bodoni Moda"'), document.fonts.load('500 12px "Instrument Sans"')]) : Promise.resolve();
    Promise.race([f, new Promise((r) => setTimeout(r, 1200))]).then(start, start);
  }

  /* ---------------- 2. Doorway page transitions ---------------- */
  function enterTransition() {
    const el = document.createElement('div');
    el.className = 'pt enter'; el.innerHTML = `<img src="${LOGO}" alt="">`;
    document.body.appendChild(el);
    root.classList.remove('pt-in'); ss.del('rb_pt');
    setTimeout(ready, 200);
    el.addEventListener('animationend', (e) => { if (e.target === el) el.remove(); });
  }
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href]'); if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return; // in-page anchor
    if (a.getAttribute('href') === '#') return;
    e.preventDefault();
    const el = document.createElement('div');
    el.className = 'pt leave'; el.innerHTML = `<img src="${LOGO}" alt="">`;
    document.body.appendChild(el);
    ss.set('rb_pt', '1');
    setTimeout(() => { location.href = url.href; }, 720);
  });
  // coming back via the back button restores a frozen page — clear any cover
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('.pt, .loader').forEach((n) => n.remove());
    root.classList.remove('preload', 'pt-in', 'hold'); ss.del('rb_pt');
  });

  if (root.classList.contains('preload')) loader();
  else if (root.classList.contains('pt-in')) enterTransition();
  else ready();

  /* ---------------- 7. Rising headlines ---------------- */
  const SPLIT = '.hero-title, .h2, .col-hero .display, .pdp-head .display, .manifesto p';
  function split(el) {
    if (el.dataset.splitHtml === el.innerHTML) return;
    const label = el.textContent.replace(/\s+/g, ' ').trim();
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((c) => {
        if (c.nodeType === 3) {
          const frag = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'w'; w.setAttribute('aria-hidden', 'true');
            const wi = document.createElement('span'); wi.className = 'wi'; wi.style.setProperty('--i', i++); wi.textContent = part;
            w.appendChild(wi); frag.appendChild(w);
          });
          node.replaceChild(frag, c);
        } else if (c.nodeType === 1 && c.tagName !== 'BR') walk(c);
      });
    };
    el.classList.remove('in');
    walk(el);
    el.classList.add('split');
    if (!el.getAttribute('aria-label') && label) el.setAttribute('aria-label', label);
    el.dataset.splitHtml = el.innerHTML;
    void el.offsetWidth; // commit the hidden state so the rise replays
    io.unobserve(el); io.observe(el);
  }

  /* ---------------- shared in-view observer ---------------- */
  const io = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    const t = e.target;
    const go = () => {
      t.classList.add('in');
      if (t.dataset.count) countUp(t);
    };
    if (root.classList.contains('hold')) document.addEventListener('rb:ready', go, { once: true }); else go();
    io.unobserve(t);
  }), { rootMargin: '0px 0px -6% 0px' });

  /* ---------------- 12a. Counters ---------------- */
  function countUp(el) {
    const m = el.dataset.count.match(/^([\d,]+)(.*)$/); if (!m) return;
    const target = +m[1].replace(/,/g, ''), suffix = m[2], t0 = performance.now(), dur = 1800;
    const fmt = (n) => Math.round(n).toLocaleString('en-US');
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt(target * e) + suffix;
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  /* ---------------- enhance: tag elements as they appear ---------------- */
  const UNROLL = '.look figure a, .interlude-media, .material-media, .pdp-gallery button:not(:first-child), .frame'; // first product photo shows at once (Largest Contentful Paint)
  const SHEEN = '.card-media, .line-media, .look figure a, .pdp-gallery button, .interlude-media';
  function enhance(scope) {
    scope.querySelectorAll(SPLIT).forEach(split);
    scope.querySelectorAll(UNROLL).forEach((el) => {
      if (el.classList.contains('unroll') || el.classList.contains('frame-seen')) return;
      if (el.classList.contains('frame')) {
        el.classList.add('frame-seen');
        if (el.closest('.wall') && !el.querySelector('.nail')) el.insertAdjacentHTML('afterbegin', '<i class="nail"></i>');
      } else el.classList.add('unroll');
      io.observe(el);
    });
    if (fine) scope.querySelectorAll(SHEEN).forEach((el) => el.classList.add('sheen'));
    scope.querySelectorAll('.fact .v.num, .voices-foot b').forEach((el) => {
      if (el.dataset.count) return;
      el.dataset.count = el.textContent.trim(); el.textContent = '0' + el.dataset.count.replace(/^[\d,]+/, '');
      io.observe(el);
    });
    // stagger cards across each row of the grid
    scope.querySelectorAll('.grid').forEach((g) => {
      const cols = parseInt(getComputedStyle(g).getPropertyValue('--cols'), 10) || 3;
      [...g.children].filter((c) => c.classList.contains('card')).forEach((c, k) => c.style.setProperty('--d', `${(k % cols) * 0.09}s`));
    });
  }
  enhance(document);
  // re-run when pages render new content (filters, tabs, search); ignore pure text updates like counters
  new MutationObserver((ms) => {
    let added = false; const resplit = new Set();
    ms.forEach((m) => {
      const s = m.target.closest && m.target.closest('.split'); if (s) resplit.add(s);
      if ([...m.addedNodes].some((n) => n.nodeType === 1 && !(n.classList && (n.classList.contains('w') || n.classList.contains('fly') || n.classList.contains('pt'))))) added = true;
    });
    resplit.forEach(split);
    if (added) enhance(document);
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------------- 8. Marquee (built from markup) ---------------- */
  const mq = document.querySelector('.marquee-track');
  let mqX = 0, mqW = 0;
  if (mq) {
    const set = mq.querySelector('.marquee-set');
    for (let k = 0; k < 2; k++) { const c = set.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.querySelectorAll('a').forEach((a) => a.tabIndex = -1); mq.appendChild(c); }
    const measure = () => { mqW = set.getBoundingClientRect().width; };
    measure(); window.addEventListener('resize', measure);
  }

  /* ---------------- 9. Label cursor ---------------- */
  const cur = fine ? document.createElement('div') : null;
  const cp = { x: -200, y: -200, tx: -200, ty: -200 };
  if (cur) {
    cur.className = 'cursor'; cur.setAttribute('aria-hidden', 'true'); document.body.appendChild(cur);
    const label = (t) => {
      if (t.closest('.pdp-gallery button')) return 'Zoom';
      if (t.closest('.card-add, button, input, select')) return '';
      if (t.closest('.ugc-wall')) return '';
      if (t.closest('.wall')) return 'Drag';
      if (t.closest('.card-media, .line-media, .look figure a')) return 'View';
      return '';
    };
    document.addEventListener('pointermove', (e) => {
      cp.tx = e.clientX; cp.ty = e.clientY;
      const l = label(e.target);
      if (l) { if (cur.textContent !== l) cur.textContent = l; cur.classList.add('on'); } else cur.classList.remove('on');
    }, { passive: true });
    document.addEventListener('pointerdown', () => cur.classList.add('press'));
    document.addEventListener('pointerup', () => cur.classList.remove('press'));
    document.documentElement.addEventListener('mouseleave', () => cur.classList.remove('on'));
  }

  /* ---------------- 5. Brushed pile ---------------- */
  let lastX = 0, lastY = 0, nap = 135;
  if (fine) document.addEventListener('pointermove', (e) => {
    const el = e.target.closest('.sheen'); const dx = e.clientX - lastX, dy = e.clientY - lastY;
    lastX = e.clientX; lastY = e.clientY;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${e.clientX - r.left}px`);
    el.style.setProperty('--my', `${e.clientY - r.top}px`);
    if (Math.abs(dx) + Math.abs(dy) > 2) {
      const a = (Math.atan2(dy, dx) * 180) / Math.PI + 90;
      nap += ((((a - nap) % 360) + 540) % 360 - 180) * 0.15; // ease toward the stroke direction
      el.style.setProperty('--nap', `${nap}deg`);
    }
  }, { passive: true });

  /* ---------------- 12b. Magnetic buttons ---------------- */
  if (fine) {
    document.addEventListener('pointermove', (e) => {
      const b = e.target.closest('.btn');
      document.querySelectorAll('.btn.magnet').forEach((o) => { if (o !== b) { o.classList.remove('magnet'); o.style.translate = ''; } });
      if (!b) return;
      const r = b.getBoundingClientRect();
      b.classList.add('magnet');
      b.style.translate = `${(e.clientX - r.left - r.width / 2) * 0.18}px ${(e.clientY - r.top - r.height / 2) * 0.3}px`;
    }, { passive: true });
  }

  /* ---------------- 6. Swinging frames ---------------- */
  const wall = document.querySelector('.wall');
  let wallLast = wall ? wall.scrollLeft : 0, ang = 0, vel = 0;

  /* ---------------- 3. Hero parallax + material zoom ---------------- */
  const heroImg = document.querySelector('.hero-arch img');
  const matImg = document.querySelector('.material-media img');
  let lastScroll = scrollY, scrollV = 0;

  /* ---------------- one frame loop for everything continuous ---------------- */
  function frame() {
    const sy = scrollY; const dv = sy - lastScroll; lastScroll = sy;
    scrollV += (dv - scrollV) * 0.12;

    if (cur) { cp.x += (cp.tx - cp.x) * 0.2; cp.y += (cp.ty - cp.y) * 0.2; cur.style.translate = `${cp.x}px ${cp.y}px`; }

    if (mq && mqW) {
      const dir = scrollV < -0.5 ? -1 : 1;
      mqX -= (0.6 + Math.abs(scrollV) * 0.35) * dir;
      if (mqX <= -mqW) mqX += mqW; if (mqX > 0) mqX -= mqW;
      mq.style.transform = `translate3d(${mqX}px,0,0) skewX(${Math.max(-8, Math.min(8, -scrollV * 0.25))}deg)`;
    }

    if (wall) {
      const d = wall.scrollLeft - wallLast; wallLast = wall.scrollLeft;
      const target = Math.max(-7, Math.min(7, -d * 0.35));
      vel += (target - ang) * 0.08; vel *= 0.86; ang += vel; // damped spring
      const frames = wall.querySelectorAll('.frame');
      if (Math.abs(ang) > 0.01 || Math.abs(vel) > 0.01) frames.forEach((f, i) => { f.style.rotate = `${ang * (0.8 + (i % 3) * 0.15)}deg`; });
    }

    if (heroImg && sy < innerHeight * 1.2) heroImg.style.translate = `0 ${Math.min(sy * 0.08, 30)}px`;
    if (matImg) {
      const r = matImg.parentElement.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) {
        const p = Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight + r.height)));
        matImg.style.scale = String(1.22 - p * 0.22);
      }
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  /* ---------------- 10. Roll into bag ---------------- */
  function fly(from) {
    const opts = from instanceof Element ? { el: from } : from;
    const bag = document.getElementById('bagCount');
    if (!opts || !opts.el || !bag) return Promise.resolve();
    const r = opts.el.getBoundingClientRect(), t = bag.getBoundingClientRect();
    if (!r.width || r.bottom < 0 || r.top > innerHeight) return Promise.resolve();
    const rot = opts.rotate || 0, swap = rot % 180 !== 0;
    const w = swap ? r.height : r.width, h = swap ? r.width : r.height;
    const img = document.createElement('img');
    img.className = 'fly'; img.src = opts.src || opts.el.currentSrc || opts.el.src; img.alt = '';
    Object.assign(img.style, { left: `${r.left + r.width / 2 - w / 2}px`, top: `${r.top + r.height / 2 - h / 2}px`, width: `${w}px`, height: `${h}px` });
    document.body.appendChild(img);
    const dx = t.left + t.width / 2 - (r.left + r.width / 2), dy = t.top + t.height / 2 - (r.top + r.height / 2);
    const s = Math.max(0.06, 26 / Math.max(w, h));
    const anim = img.animate([
      { transform: `translate(0,0) rotate(${rot}deg) scale(1,1)`, borderRadius: '0px' },
      { offset: 0.35, transform: `translate(0,-24px) rotate(${rot}deg) scale(1,0.14)`, borderRadius: '999px' },
      { transform: `translate(${dx}px,${dy}px) rotate(${rot + 20}deg) scale(${s},${s * 0.55})`, borderRadius: '999px', opacity: 0.4 },
    ], { duration: 950, easing: 'cubic-bezier(.6,.04,.2,1)', fill: 'forwards' });
    return anim.finished.then(() => {
      img.remove();
      bag.classList.remove('bump'); void bag.offsetWidth; bag.classList.add('bump');
      return new Promise((res) => setTimeout(res, 180));
    });
  }

  window.RBMotion = { fly, split };
})();
